// @flow
import React, { Component } from 'react';
import { injectIntl, type IntlShape } from 'react-intl';

import type { IngestConfigField } from 'state/types';
import { displayNameForField } from 'util/fieldsPageUtils';

type Props = {
  disabled?: boolean,
  field: IngestConfigField,
  intl: IntlShape,
  onDoubleClick: string => void,
  onRequiredClick: string => void,
};

class ManagedUploadField extends Component<Props> {
  handleCheckboxClick: Function;
  handleDoubleClick: Function;

  constructor() {
    super();

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
  }

  handleCheckboxClick() {
    const {
      field: {
        fieldDefinition: { id },
      },
    } = this.props;
    this.props.onRequiredClick(id);
  }

  handleDoubleClick() {
    const {
      field: {
        fieldDefinition: { id },
      },
      onDoubleClick,
    } = this.props;
    onDoubleClick(id);
  }

  render() {
    const {
      disabled,
      field: { fieldDefinition, required },
      intl,
    } = this.props;
    const id = `uploadField-${fieldDefinition.id}`;
    return (
      <div className="columns" onDoubleClick={this.handleDoubleClick}>
        <div className="column is-one-quarter">
          <input
            checked={required}
            className="is-checkradio"
            disabled={disabled}
            id={id}
            onChange={this.handleCheckboxClick}
            type="checkbox"
            data-test-name='field-isRequired'
          />
          <label style={{ marginRight: 0, paddingRight: 0 }} htmlFor={id} />
        </div>
        <div className="column is-three-quarters">
          <span
            className={`${disabled ? 'has-text-grey' : 'has-text-grey-darker'}`}
            data-test-name='display-name'
          >
            {displayNameForField(intl, fieldDefinition.systemName)}
          </span>
        </div>
      </div>
    );
  }
}

export default injectIntl(ManagedUploadField);



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/ManagedFields/ManagedUploadField.js